// extracted by mini-css-extract-plugin
module.exports = {"root":"root-7W-0m","rotation":"rotation-OGnWg","loading":"loading-H1qxG","content":"content-W11WC"};